// @ts-nocheck
import Papa from 'papaparse';
import { format } from 'date-fns';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const exportToCSV = (data: any[], filename: string) => {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${format(new Date(), 'yyyy-MM-dd')}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToJSON = (data: any[], filename: string) => {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${format(new Date(), 'yyyy-MM-dd')}.json`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export interface PDFExportOptions {
  title?: string;
  subtitle?: string;
  columns?: Array<{ header: string; dataKey: string }>;
  filename?: string;
}

export const exportToPDF = (
  data: any[],
  options: PDFExportOptions = {}
) => {
  const {
    title = 'Report',
    subtitle,
    columns,
    filename = `report_${format(new Date(), 'yyyy-MM-dd')}`,
  } = options;

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 14;
  let yPos = margin;

  // Title
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(title, margin, yPos);
  yPos += 10;

  // Subtitle
  if (subtitle) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(subtitle, margin, yPos);
    yPos += 8;
  }

  // Date
  doc.setFontSize(10);
  doc.setFont('helvetica', 'italic');
  doc.text(`Generated: ${format(new Date(), 'MMM dd, yyyy HH:mm')}`, margin, yPos);
  yPos += 10;

  // Prepare table data
  if (data.length === 0) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text('No data to export', margin, yPos);
    doc.save(`${filename}.pdf`);
    return;
  }

  // Auto-detect columns if not provided
  const tableColumns = columns || Object.keys(data[0]).map((key) => ({
    header: key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
    dataKey: key,
  }));

  // Prepare table rows
  const tableRows = data.map((row) =>
    tableColumns.map((col) => {
      const value = row[col.dataKey];
      if (value === null || value === undefined) return '';
      if (typeof value === 'object') return JSON.stringify(value);
      return String(value);
    })
  );

  // Add table
  (doc as any).autoTable({
    head: [tableColumns.map((col) => col.header)],
    body: tableRows,
    startY: yPos,
    margin: { top: yPos, left: margin, right: margin },
    styles: {
      fontSize: 8,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [66, 139, 202], // Luna secondary color (approximate)
      textColor: 255,
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    columnStyles: {},
  });

  // Save PDF
  doc.save(`${filename}.pdf`);
};

